// #region Dependencias
import styled, { css } from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos

export const sharedButtonStyle = css`
  all: unset;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  color: ${colors.white};
  cursor: pointer;
  font-weight: bold;
  margin: ${({ align = 'center' }) =>
    align === 'right'
      ? 'auto 0 .5rem auto'
      : align === 'left'
      ? 'auto auto .5rem 0'
      : '.5rem auto .5rem auto'};
  padding: ${({ size = 'normal' }) => (size === 'small' ? '.5rem 1rem' : '1rem 2rem')};
  text-align: center;
  text-transform: uppercase;
  transition: transform 0.15s, color 0.15s, filter 0.15s;
  user-select: none;
  white-space: nowrap;

  &:hover {
    filter: brightness(0.9);
  }

  &:active {
    transform: scale(0.975);
  }

  ${({ disabled }) =>
    disabled &&
    `
  transform: scale(1);
  filter: brightness(1);
  filter: opacity(0.75);
  `}
`

const StyledButton = styled.button.attrs((props) => ({
  style: {
    backgroundColor:
      props.color === 'primary'
        ? colors.primary
        : props.color === 'secondary'
          ? colors.secondary
          : props.color === 'tertiary'
            ? colors.tertiary
            : props.color === 'dark'
              ? colors.text
              : props.color,
    borderRadius: `${props.borderradius}rem`
  }
}))`
  ${sharedButtonStyle}
`
// #endregion

/**
 * Componente que renderiza un botón.
 *
 * @class
 * @example
 * <Button align="center" color="primary" disabled={false} size="small" text="Enviar" type="submit" />
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.align="center"] - Alineación del componente.
 * @param {string} props.borderradius - Radio de las esquinas del componente.
 * @param {string} [props.color="primary"] - Color de fondo del botón.
 * @param {boolean} [props.disabled=false] - Valor que indica si el botón está desactivado.
 * @param {Object} [props.size="normal"] - Tamaño del botón.
 * @param {string} [props.type="button"] - Tipo de botón.
 * @param {string} props.text - Texto del botón.
 */
const Button = ({ disabled = false, text, type = 'button', ...props }) => {
  return (
    <StyledButton disabled={disabled} type={type} {...props}>
      {text}
    </StyledButton>
  )
}

export default Button
